<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">{{ isEdicao ? 'Editar Forma de Envio' : 'Nova Forma de Envio' }}</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
          Cadastre e configure como os pedidos serão enviados aos seus clientes.
        </p>
      </div>
    </div>

    @if (isLoading) {
    <!-- Dados gerais -->
    <div class="section-container">
      <app-loading-box height="22" width="180" marginTop="0"></app-loading-box>
      <div class="row mt-3">
        <div class="col-md-4 col-12">
          <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        </div>
        <div class="col-md-8 col-12">
          <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        </div>
        <div class="col-12">
          <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        </div>
        <div class="col-md-6 col-12">
          <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        </div>
        <div class="col-md-6 col-12">
          <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        </div>
        <div class="col-12">
          <app-loading-box height="32" width="120" marginTop="16"></app-loading-box>
        </div>
      </div>
    </div>

    <!-- Bloco de configurações específicas do tipo -->
    <div class="section-container mt-4">
      <app-loading-box height="22" width="240" marginTop="0"></app-loading-box>
      <div class="row mt-3">
        <div class="col-md-4 col-12">
          <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        </div>
        <div class="col-md-4 col-12">
          <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        </div>
        <div class="col-md-4 col-12">
          <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        </div>
      </div>
    </div>

    <!-- Bloco de itens (fretes) -->
    <div class="section-container mt-4">
      <app-loading-box height="22" width="280" marginTop="0"></app-loading-box>
      <app-loading-box height="36" width="200" marginTop="16"></app-loading-box>
      <app-loading-box height="64" width="100%" marginTop="12"></app-loading-box>
      <app-loading-box height="64" width="100%" marginTop="8"></app-loading-box>
    </div>
    } @else {
    <form [formGroup]="form">

      <!-- ——— Dados gerais ——— -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon>local_shipping</mat-icon>
          <span>Dados gerais</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo logística</mat-label>
              <mat-select formControlName="idTipoLogistica">
                @for (tipo of tiposLogistica; track tipo.idTipoLogistica) {
                <mat-option [value]="tipo.idTipoLogistica">{{ tipo.descricao }}</mat-option>
                }
              </mat-select>
              @if (isEdicao) {
              <mat-hint>Não pode ser alterado após a criação</mat-hint>
              }
              @if (form.get('idTipoLogistica')?.hasError('required')) {
              <mat-error>Selecione o tipo de logística</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-8 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição da forma de envio</mat-label>
              <input matInput formControlName="descricao" placeholder="Ex: Correios, Transportadora própria…">
              @if (form.get('descricao')?.hasError('required')) {
              <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>URL de rastreamento padrão</mat-label>
              <input matInput formControlName="urlRastreamento" placeholder="Opcional">
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Imprimir automaticamente ao finalizar embalagem</mat-label>
              <mat-select formControlName="impressaoEmbalagem" [multiple]="true">
                @for (doc of tiposDocumentoImpressao; track doc.idTipoDocumentoImpressao) {
                <mat-option [value]="doc.idTipoDocumentoImpressao">{{ doc.descricao }}</mat-option>
                }
              </mat-select>
              <mat-hint>Vazio = Não imprimir</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Imprimir automaticamente ao finalizar expedição</mat-label>
              <mat-select formControlName="impressaoExpedicao" [multiple]="true">
                @for (doc of tiposDocumentoImpressao; track doc.idTipoDocumentoImpressao) {
                <mat-option [value]="doc.idTipoDocumentoImpressao">{{ doc.descricao }}</mat-option>
                }
              </mat-select>
              <mat-hint>Vazio = Não imprimir</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 d-flex align-items-center" style="gap:12px; margin-bottom: 8px;">
            <mat-slide-toggle formControlName="isAtivo" color="primary">Ativo</mat-slide-toggle>
          </div>
        </div>
      </div>

      <!-- ——— CUSTOMIZADO ——— -->
      @if (isCustomizado) {

      <!-- Configurações adicionais (Customizado) -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>tune</mat-icon>
          <span>Configurações adicionais</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Modelo da etiqueta para impressão</mat-label>
              <mat-select formControlName="idModeloEtiqueta">
                <mat-option [value]="null">Selecione</mat-option>
                @for (etiqueta of etiquetasTransportadora; track etiqueta.id) {
                <mat-option [value]="etiqueta.id">{{ etiqueta.descricao }}</mat-option>
                }
              </mat-select>
              <mat-hint>Etiquetas configuradas do tipo Transportadora.</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Configurações das formas de frete (Customizado) -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Configurações das formas de frete</span>
        </div>
        <div class="d-flex justify-content-end mb-2">
          <button type="button" mat-button (click)="adicionarFrete()">
            <span class="material-symbols-outlined">add_circle</span>
            Adicionar forma de frete
          </button>
        </div>
        <div class="row mt-3">
          @if (formasFrete.length > 0) {
          <div class="col-12 mt-2">
            @for (frete of formasFrete; track $index) {
            <div class="item-card">
              <span class="item-card-icon">
                <span class="material-symbols-outlined">local_shipping</span>
              </span>
              <div class="item-card-body">
                <div class="item-card-title">{{ frete.descricao }}</div>
                <div class="item-card-sub">
                  {{ frete.codigoServico ? 'Código ' + frete.codigoServico + ' · ' : '' }}{{
                  getNomeTipoEntrega(frete.idTipoEntrega) }}
                </div>
              </div>
              <button type="button" mat-icon-button (click)="editarFrete($index)">
                <span class="material-symbols-outlined">edit</span>
              </button>
              <button type="button" mat-icon-button (click)="removerFrete($index)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>

      }
      <!-- ——— FIM CUSTOMIZADO ——— -->

      <!-- ——— CORREIOS ——— -->
      @if (isCorreios) {

      <!-- Configurações dos Correios -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>local_post_office</mat-icon>
          <span>Configurações dos Correios</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Possui contrato</mat-label>
              <mat-select formControlName="possuiContrato">
                <mat-option [value]="true">Sim</mat-option>
                <mat-option [value]="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <app-select-pesquisavel [control]="transportadorCorreiosControl" label="Transportador"
              [apiUrl]="urlTransportador" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>
        </div>
      </div>

      <!-- Configurações de autenticação -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>key</mat-icon>
          <span>Configurações de autenticação</span>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="utilizarOutroCnpj">
                Utilizar outro CNPJ
              </mat-slide-toggle>
              <span class="info-text">
                Quando habilitado, utilizaremos outro CNPJ para fazer a sua autenticação.
              </span>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Usuário do portal Meu Correios</mat-label>
              <input matInput formControlName="usuarioCorreios">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Senha de acesso à API</mat-label>
              <input matInput type="password" formControlName="senhaCorreios">
              <mat-hint>Deve ser gerada no painel do Correios Web Services.</mat-hint>
            </mat-form-field>
          </div>
          @if (form.value.utilizarOutroCnpj) {
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNPJ do portal Meu Correios</mat-label>
              <input matInput formControlName="cnpjCorreios" type="text" [mask]="masks.cnpj"
                placeholder="00.000.000/0000-00">
              @if (form.get('cnpjCorreios')?.hasError('required')) {
              <mat-error>O CNPJ é <strong>obrigatório</strong></mat-error>
              }
              @if (form.get('cnpjCorreios')?.hasError('cnpjInvalido')) {
              <mat-error>CNPJ inválido</mat-error>
              }
            </mat-form-field>
          </div>
          }
        </div>
      </div>

      <!-- Configurações adicionais (Correios) -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>tune</mat-icon>
          <span>Configurações adicionais</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Habilitar atualização automática de rastreios</mat-label>
              <mat-select formControlName="habilitarAtualizacaoAutomaticaRastreios">
                <mat-option [value]="false">Não</mat-option>
                <mat-option [value]="true">Sim</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Utiliza Declaração de Conteúdo Eletrônica (DC-e)</mat-label>
              <mat-select formControlName="utilizaDCe">
                <mat-option [value]="false">Não</mat-option>
                <mat-option [value]="true">Sim</mat-option>
              </mat-select>
              <mat-hint>Ao marcar "Sim", expedições sem NF exigirão emissão de DC-e.</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Configurações de postagem -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>markunread_mailbox</mat-icon>
          <span>Configurações de postagem</span>
        </div>
        <p class="section-subtitle">Localize os dados abaixo no seu Cartão Correios Fácil.</p>

        <div class="cartao-ajuda">
          <div class="cartao-correios">
            <div class="cartao-correios-header">
              <span class="material-symbols-outlined">local_post_office</span>
              <span>CARTÃO CORREIOS FÁCIL</span>
            </div>
            <ul class="cartao-correios-dados">
              <li><span class="badge-num">3</span><span><strong>Cód. admin.:</strong> 00000000</span></li>
              <li><span class="badge-num">1</span><span><strong>Nº cartão:</strong> 00XXXXXXXX</span></li>
              <li><span class="badge-num">5</span><span><strong>Cliente:</strong> TINY SOFTWARE LTDA</span></li>
            </ul>
            <div class="cartao-correios-footer">Postagem em todas as agências dos Correios</div>
          </div>

          <div class="cartao-legenda">
            <div class="cartao-legenda-title">Onde encontrar cada informação</div>
            <ul>
              <li><span class="badge-num">1</span>Número do cartão de postagem</li>
              <li><span class="badge-num">2</span>Diretoria Regional (DR)</li>
              <li><span class="badge-num">3</span>Código administrativo</li>
              <li><span class="badge-num">4</span>Número do contrato</li>
              <li><span class="badge-num">5</span>Nome do cliente</li>
            </ul>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número do cartão de postagem <span class="label-num">1</span></mat-label>
              <input matInput formControlName="numeroCartaoPostagem">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Unidade de postagem</mat-label>
              <input matInput formControlName="unidadePostagem">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Diretoria regional (DR) <span class="label-num">2</span></mat-label>
              <mat-select formControlName="diretoriaRegional">
                <mat-option [value]="null">Selecione</mat-option>
                @for (uf of listaUf; track uf.id) {
                <mat-option [value]="uf.id">{{ uf.descricaoExibicao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="utilizarDataExpedicaoPostagem">
                Utilizar data da expedição como data prevista de postagem
              </mat-slide-toggle>
              <span class="info-text">Caso utilize algum serviço de carta para o envio do pacote, é necessário informar
                uma previsão de data de quando o objeto será postado. Nesse caso, uma vez habilitada, utilizaremos a
                data em que foi concluída a expedição como valor padrão.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Configurações do contrato -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>description</mat-icon>
          <span>Configurações do contrato</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código administrativo <span class="label-num">3</span></mat-label>
              <input matInput formControlName="codigoAdministrativo">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número do contrato <span class="label-num">4</span></mat-label>
              <input matInput formControlName="numeroContrato">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ano do contrato</mat-label>
              <input matInput formControlName="anoContrato" type="text" [mask]="masks.year" placeholder="AAAA">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome do cliente <span class="label-num">5</span></mat-label>
              <input matInput formControlName="nomeCliente" placeholder="Opcional">
              <mat-hint>Utilizado apenas na impressão da chancela.</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Configurações de cotação -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>calculate</mat-icon>
          <span>Configurações de cotação</span>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Utilizar as dimensões mínimas</mat-label>
              <mat-select formControlName="utilizarDimensoesMinimas">
                <mat-option [value]="false">Não</mat-option>
                <mat-option [value]="true">Sim</mat-option>
              </mat-select>
              <mat-hint>Válido apenas para cotações pelas APIs de frete.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 mt-2">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="agruparProdutosEmbalagem">
                Agrupar produtos por embalagem
              </mat-slide-toggle>
              <span class="info-text">Quando habilitado, utilizaremos as embalagens cadastradas para agrupar os produtos
                da venda.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Configurações de expedição -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>outbox</mat-icon>
          <span>Configurações de expedição</span>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-4">
            <p>Para pedidos com valor declarado inferior ao mínimo permitido pelos Correios
              (R$ 25,63):</p>
            <mat-radio-group formControlName="isMarcarMinimoValorDeclarado" class="radio-col">
              <mat-radio-button [value]="false">Não utilizar valor declarado</mat-radio-button>
              <mat-radio-button [value]="true">Marcar valor declarado como o mínimo dos Correios de R$
                25,63</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-12 mb-4">
            <p>Para pedidos com valor declarado inferior ao mínimo permitido pelos Mini Envios
              (R$ 12,82):</p>
            <mat-radio-group formControlName="isMarcarMinimoValorDeclaradoMini" class="radio-col">
              <mat-radio-button [value]="false">Não utilizar valor declarado para Mini Envios</mat-radio-button>
              <mat-radio-button [value]="true">Marcar valor declarado como o mínimo dos Mini Envios de R$
                12,82</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-lg-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Prazo de postagem</mat-label>
              <input matInput type="number" formControlName="prazoPostagemConvencional" min="0" max="90">
              <span matTextSuffix>dias</span>
              <mat-hint>Prazo máximo definido pelos Correios é de até 90 dias.</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Configurações das formas de frete (Correios) -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Configurações das formas de frete</span>
        </div>
        <div class="d-flex justify-content-end mb-2">
          <button type="button" mat-stroked-button class="btn-secondary" (click)="buscarServicos()"
            [disabled]="isBuscarFretesLoading">
            @if (isBuscarFretesLoading) {
            <mat-spinner [diameter]="18"></mat-spinner>
            } @else {
            <mat-icon>search</mat-icon>
            buscar formas de frete
            }
          </button>
        </div>
        <div class="row mt-3">
          @if (formasFrete.length > 0) {
          <div class="col-12 mb-2">
            @for (frete of formasFrete; track $index) {
            <div class="item-card">
              <span class="item-card-icon">
                <span class="material-symbols-outlined">local_shipping</span>
              </span>
              <div class="item-card-body">
                <div class="item-card-title">{{ frete.descricao }}</div>
                <div class="item-card-sub">{{ frete.codigoServico || '' }}{{ frete.codigoServico ? ' · ' : '' }}{{
                  getNomeTipoEntrega(frete.idTipoEntrega) }}</div>
              </div>
              <button type="button" mat-icon-button (click)="editarFrete($index)">
                <span class="material-symbols-outlined">edit</span>
              </button>
              <button type="button" mat-icon-button (click)="removerFrete($index)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>

      <!-- Logística Reversa -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>undo</mat-icon>
          <span>Logística Reversa</span>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-3">
            <app-alert-card type="info">
              Para utilizar a logística reversa é necessário um usuário e senha especiais. Essas credenciais
              diferem dos dados do Sigep WEB e do usuário e senha da interface de logística reversa.
            </app-alert-card>
          </div>
          <div class="col-lg-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Usuário Logística Reversa</mat-label>
              <input matInput formControlName="usuarioLogisticaReversa">
            </mat-form-field>
          </div>
          <div class="col-lg-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Senha Logística Reversa</mat-label>
              <input matInput type="password" formControlName="senhaLogisticaReversa">
            </mat-form-field>
          </div>
          <div class="col-lg-6 col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Prazo de postagem</mat-label>
              <input matInput type="number" formControlName="prazoPostagemReversa" min="0" max="90">
              <span matTextSuffix>dias</span>
              <mat-hint>Validade da etiqueta é de até 90 dias.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 mt-2 d-flex justify-content-end">
            <button type="button" mat-button (click)="adicionarServicoReversa()">
              <span class="material-symbols-outlined">add_circle</span>
              Adicionar serviço(s)
            </button>
          </div>
          @if (servicosReversa.length > 0) {
          <div class="col-12 mt-2">
            @for (srv of servicosReversa; track $index) {
            <div class="item-card">
              <span class="item-card-icon">
                <span class="material-symbols-outlined">undo</span>
              </span>
              <div class="item-card-body">
                <div class="item-card-title">{{ srv.descricao }}</div>
                @if (srv.codigoServico) {
                <div class="item-card-sub">Código {{ srv.codigoServico }}</div>
                }
              </div>
              <button type="button" mat-icon-button (click)="editarServicoReversa($index)">
                <span class="material-symbols-outlined">edit</span>
              </button>
              <button type="button" mat-icon-button (click)="removerServicoReversa($index)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>

      }
      <!-- ——— FIM CORREIOS ——— -->

    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
